import styled from 'styled-components';
import { Icon } from 'modules/core/components';

export const TrashIcon = styled(Icon)`
  top: 5px;
  position: relative;
  cursor: pointer;
`;
